export default __webpack_public_path__ + "static/media/instrukcja-mumu-premium.9e1a5a8e.pdf";